export const isHpEmail = async (value: string[]) => {
  if (!value.length) {
    return `Field must not be empty`
  }
  const emailRegex = /^(\w+[+.-]?)*@hp\.com$/
  const isValid = value.every((el) => emailRegex.test(el))
  return !isValid ? 'The field Email has an incorrect value. Format: [aaa]@[hp].[com]' : ''
}
